var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 35,
    viewBox: "0 0 106 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.94889 3.31234C5.94889 1.72137 4.65916 0.431641 3.0682 0.431641C1.47723 0.431641 0.1875 1.72137 0.1875 3.31234V22.517C0.1875 29.4112 5.77634 35 12.6705 35C19.5647 35 25.1535 29.4112 25.1535 22.517C25.1535 15.6228 19.5647 10.034 12.6705 10.034C11.0796 10.034 9.78982 11.3237 9.78982 12.9147C9.78982 14.5056 11.0796 15.7954 12.6705 15.7954C16.3828 15.7954 19.3921 18.8047 19.3921 22.517C19.3921 26.2292 16.3828 29.2386 12.6705 29.2386C8.95827 29.2386 5.94889 26.2292 5.94889 22.517V3.31234Z",
    fill: "url(#paint0_linear_597_1236)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.932 0.431641C101.341 0.431641 100.052 1.72137 100.052 3.31234V22.517C100.052 26.2292 97.0423 29.2386 93.33 29.2386C89.6178 29.2386 86.6084 26.2292 86.6084 22.517C86.6084 18.8047 89.6178 15.7954 93.33 15.7954C94.921 15.7954 96.2107 14.5056 96.2107 12.9147C96.2107 11.3237 94.921 10.034 93.33 10.034C86.4358 10.034 80.847 15.6228 80.847 22.517C80.847 29.4112 86.4358 35 93.33 35C100.224 35 105.813 29.4112 105.813 22.517V3.31234C105.813 1.72137 104.523 0.431641 102.932 0.431641Z",
    fill: "url(#paint1_linear_597_1236)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4833 15.7954C63.6873 15.7954 62.0612 16.4959 60.8532 17.6444C59.5613 18.8725 58.7617 20.5989 58.7617 22.517V32.1193C58.7617 33.7103 57.4719 35 55.881 35C54.29 35 53.0003 33.7103 53.0003 32.1193V22.517C53.0003 18.9559 54.4952 15.7393 56.8835 13.4687C59.1197 11.3429 62.1517 10.034 65.4833 10.034C72.3775 10.034 77.9663 15.6228 77.9663 22.517V32.1193C77.9663 33.7103 76.6766 35 75.0856 35C73.4946 35 72.2049 33.7103 72.2049 32.1193V22.517C72.2049 18.8047 69.1955 15.7954 65.4833 15.7954Z",
    fill: "url(#paint2_linear_597_1236)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7774 27.7174L44.7799 27.7204C45.2768 27.313 45.9124 27.0685 46.6051 27.0685C48.1961 27.0685 49.4858 28.3582 49.4858 29.9492C49.4858 30.91 49.0155 31.7609 48.2925 32.2843C43.3916 36.1955 36.2286 35.882 31.6904 31.3438C26.8155 26.4689 26.8155 18.5651 31.6904 13.6902C36.5359 8.8447 44.3733 8.8154 49.2554 13.6023C50.4378 14.7617 50.4459 16.6623 49.2762 17.832L43.2264 23.8818C42.1014 25.0068 40.2774 25.0068 39.1525 23.8818C38.0275 22.7568 38.0275 20.9328 39.1525 19.8079L42.776 16.1844C40.4069 15.3413 37.6599 15.8685 35.7643 17.7641C33.1394 20.389 33.1394 24.6449 35.7643 27.2699C38.2307 29.7362 42.137 29.8855 44.7774 27.7174Z",
    fill: "url(#paint3_linear_597_1236)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_597_1236",
    x1: 0.187501,
    y1: 17.7123,
    x2: 105.813,
    y2: 17.7123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EC060"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_597_1236",
    x1: 0.187501,
    y1: 17.7123,
    x2: 105.813,
    y2: 17.7123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EC060"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_597_1236",
    x1: 0.187501,
    y1: 17.7123,
    x2: 105.813,
    y2: 17.7123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EC060"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_597_1236",
    x1: 0.187501,
    y1: 17.7123,
    x2: 105.813,
    y2: 17.7123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EC060"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.be24587fcf508c6c679028e3fe40b058.svg";
export { ForwardRef as ReactComponent };